import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { GiHouse } from "react-icons/gi";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, reset } from "../features/auth/authSlice";
import { LinkContainer } from "react-router-bootstrap";
import { getEmployees, updateEmployeeShow, resetEmployeeShow } from "../features/employees/employeeSlice";


const Header = () => {
    const navigate=useNavigate()
    const dispatch=useDispatch()

    const {user} = useSelector((state)=>state.auth)

	const logoutHandler = () => {
		dispatch(logout());
		// dispatch(reset());
		// dispatch(getEmployees());
		// navigate("/");
	};

    return (
		<header>
			<Navbar
				fixed="top"
				bg="dark"
				variant="dark"
				expand="lg"
				collapseOnSelect
			>
				<Container>
					<LinkContainer to="/">
						<Navbar.Brand>
							<GiHouse className="nav-icon" /> Real Pharma
						</Navbar.Brand>
					</LinkContainer>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse
						id="basic-navbar-nav"
						className="justify-content-end"
					>
						<Nav className="ml-auto">
							<LinkContainer to="/">
								<Nav.Link>Home</Nav.Link>
							</LinkContainer>
							<LinkContainer to="/employees">
								<Nav.Link>Employees</Nav.Link>
							</LinkContainer>

							{user ? (
								<NavDropdown
									title={
										user.username
											? user.username
											: "Welcome"
									}
									id="username"
								>
									<LinkContainer to="/profile">
										<NavDropdown.Item>
											Profile
										</NavDropdown.Item>
									</LinkContainer>

									<NavDropdown.Item onClick={logoutHandler}>
										<FaSignOutAlt /> Logout
									</NavDropdown.Item>
								</NavDropdown>
							) : (
								<LinkContainer to="/login">
									<Nav.Link>
										<FaSignInAlt /> Login
									</Nav.Link>
								</LinkContainer>
							)}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</header>
	);
};

export default Header;